import React, { useState, memo } from "react";
import PropTypes from "prop-types";
import {
  OverlayView,
} from "react-google-maps";

// eslint-disable-next-line react/display-name
const ParkingMapMarker = memo((props) => {
  const {
    item,
    onClick
  } = props;
  const [showInfo, setShowInfo] = useState(false);

  let styles = {
    boxShadow: "none",
    zIndex: 10
  };
  if (showInfo) {
    styles = {
      boxShadow: "0 0 25px 12px #008B00",
      zIndex: 1000
    };
  }

  const style = {
    backgroundColor: item.active ? "#84ff00" : "#808080",
  };

  if (!item.location || !item.location.latitude || !item.location.latitude) {
      console.log("Please remove item", item.id);
    return null;
  }

  return (
    <OverlayView
      position={{
        lat: item.location.latitude,
        lng: item.location.longitude
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        className="markerBikeBox"
        style={styles}
      >
        <div
          className="markerBike"
          onMouseEnter={() => setShowInfo(true)}
          onClick={() => onClick(item.id)}
          style={style}
        >
          {showInfo && (
            <div
              className="markerBikePopup xl"
              onClick={() => props.showPositionFromMap(item)}
              onBlur={() => setShowInfo(false)}
            >
              <div>ID: {item.id}</div>
              <div>Active: {item.active ? "Yes" : "No"}</div>
            </div>
          )}
        </div>
      </div>

    </OverlayView>
  );
});

ParkingMapMarker.propTypes = {
  item: PropTypes.object.isRequired
};

export default ParkingMapMarker;



// WEBPACK FOOTER //
// ./src/views/pages/scooter/parking/map-marker.js